export default __webpack_public_path__ + "static/cs-email-automation-8d7c0f42a696a0bf9291a714f5bc02ec.jpg";